import React, { useState } from 'react';
import '../../styles/cricket/MatchTVStream.css';

const MatchTVStream = ({ matchId, matchName, gmid }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // Check whether this is a virtual match.
    // If either matchId or gmid contains "v", use the virtual TV URL.
    const isVirtualMatch =
        String(matchId || '').toLowerCase().includes('v') ||
        String(gmid || '').toLowerCase().includes('v');

    // TV URL
    const tvUrl = isVirtualMatch
        ? 'https://live.crownexch.com/'
        : `https://e765432.diamondcricketid.com/tvd247.php?1=1&sportid=4&gmid=${matchId}`;

    const handleIframeLoad = () => {
        setLoading(false);
        setError(false);
    };

    const handleIframeError = () => {
        setLoading(false);
        setError(true);
    };

    return (
        <div className="tv-stream-container">

            <div className="tv-player-wrapper">

                {loading && (
                    <div className="tv-loading">
                        <div className="spinner"></div>
                        <p>Loading stream...</p>
                    </div>
                )}

                {error ? (
                    <div className="tv-error">
                        <p>📺 Stream Unavailable</p>
                        <small>Could not load the video stream.</small>
                    </div>
                ) : (
                    <iframe
                        src={tvUrl}
                        onLoad={handleIframeLoad}
                        onError={handleIframeError}
                        width="100%"
                        style={{ height: '225px' }}
                        className="video-iframe"
                        allow="autoplay; fullscreen"
                        allowFullScreen
                        referrerPolicy="no-referrer"
                        title={`TV Stream for ${matchName}`}
                    />
                )}

            </div>

        </div>
    );
};

export default MatchTVStream;